"use client";
import * as RadixCheckbox from "@radix-ui/react-checkbox";
import Icon from "./icon";
import React from "react";

export interface CheckboxProps extends RadixCheckbox.CheckboxProps {
  id: string;
  label: string | React.ReactNode;
  className?: string;
}

export default function Checkbox(props: CheckboxProps) {
  return (
    <>
      <div className="flex items-center gap-2">
        <RadixCheckbox.Root
          {...props}
          className={`flex justify-center items-center data-[state=checked]:bg-primary hover:bg-surface-600 border-[2px] border-secondary-500 data-[state=checked]:border-primary rounded-sm w-5 h-5 appearance-none shrink-0 outline-none ${props.className}`}
          id={props.id}
        >
          <RadixCheckbox.Indicator>
            <Icon name="checkmark" size="sm" color="dark" />
          </RadixCheckbox.Indicator>
        </RadixCheckbox.Root>
        <label
          className="text-label text-secondary-500 md:text-sm"
          htmlFor={props.id}
        >
          {props.label}
        </label>
      </div>
    </>
  );
}
